import { useMutation, useQueryClient } from '@tanstack/react-query'
import { liveCheckinMonthsLevelsRewardsService } from '../../services/lives-checkins-months-levels-rewards'
import { MONTH_REWARDS_KEY } from './use-get-month-rewards'
import { GET_OR_CREATE_MONTH_KEY } from './use-get-or-create-month'

export function useClaimReward() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (liveCheckinMonthLevelRewardId: number) =>
      liveCheckinMonthsLevelsRewardsService.claim({ liveCheckinMonthLevelRewardId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MONTH_REWARDS_KEY] })
      queryClient.invalidateQueries({ queryKey: [GET_OR_CREATE_MONTH_KEY] })
    },
  })

  return {
    claim: mutation.mutate,
    claimAsync: mutation.mutateAsync,
    isClaiming: mutation.isPending,
    error: mutation.error,
    lastClaimed: mutation.data?.data ?? null,
  }
}
